const axios = require('axios');

const vapidPublicKey =
"BNZFMWZpawzLbt3m9JC6BT6iws9puQGdaNXGlJGW9uZTCxV-yYoyQnfYMlnW0KAbj3ixcFiWvL-fJJU8xfplFxM"
const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey)

function urlBase64ToUint8Array(base64String) {
const padding = "=".repeat((4 - base64String.length % 4) % 4)
const base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/")

const rawData = window.atob(base64)
const outputArray = new Uint8Array(rawData.length)

for (let i = 0; i < rawData.length; ++i) {
  outputArray[i] = rawData.charCodeAt(i)
}
return outputArray
}

export const subscribePushNotifications = (reg,sub,uid) => {
    console.log("sub",sub)
    if(sub){
        axios.post(`https://recruitingmonk-v2.azurewebsites.net/push/subscribe/${uid}`, sub)
        .catch(err => console.error("Push subscription update error: ", err))
        return;
    }
    reg.pushManager
      .subscribe({
        userVisibleOnly: true, //Always display notifications
        applicationServerKey: convertedVapidKey
      })
      .then(subscription => axios.post(`https://recruitingmonk-v2.azurewebsites.net/push/subscribe/${uid}`, subscription))
      .then(() => console.log("Push Notification Subscribed!"))
      .catch(err => console.error("Push subscription error: ", err))
}